var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-address"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.address !== null) ? _c('span', {
    staticStyle: {
      "border-bottom": "1px dotted gray"
    }
  }, [(_vm.client.address.is_old_address === true) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', {
    staticClass: "text-success"
  }, [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.client.address.full_address))])]) : _c('span', {
    staticStyle: {
      "border-bottom": "1px dotted gray"
    }
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Chybí adresa bydliště")])])]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "container tooltip_container tooltip_1_col"
  }, [_c('div', {
    staticClass: "row tooltip_header"
  }, [_c('div', {
    staticClass: "col-sm-2 text-left"
  }, [(_vm.editMode === false && _vm.client.address) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "client-address-edit"
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" upravit")]) : (_vm.editMode === true && _vm.client.address) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    attrs: {
      "data-testid": "client-address-back"
    },
    on: {
      "click": _vm.view
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" zpět")]) : _vm._e()]), _vm._v(" "), (_vm.client.address === null && _vm.editMode === true) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Nastavení adresy trvalého bydliště")]) : (_vm.editMode === true) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Úprava adresy trvalého bydliště")]) : _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("Adresa trvalého bydliště")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  })]), _vm._v(" "), (_vm.editMode === true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 tooltip_body text-left"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "row justify-content-around"
  }, [_c('span', [_vm._v("Česká")]), _vm._v(" "), _c('label', {
    staticClass: "switch switch-lg switch-text switch-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchOutsideCzechia),
      expression: "searchOutsideCzechia"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "searchInCzechia",
      "data-testid": "client-address-foreign-toggle"
    },
    domProps: {
      "checked": Array.isArray(_vm.searchOutsideCzechia) ? _vm._i(_vm.searchOutsideCzechia, null) > -1 : (_vm.searchOutsideCzechia)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.searchOutsideCzechia,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.searchOutsideCzechia = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.searchOutsideCzechia = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.searchOutsideCzechia = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "",
      "data-off": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('span', [_vm._v("zahraniční")])]), _vm._v(" "), (!_vm.searchOutsideCzechia) ? [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('multiselect', {
    attrs: {
      "reset-after": true,
      "id": "search",
      "data-testid": "client-address-search-czech",
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat adresu",
      "open-direction": "bottom",
      "options": _vm.addresses,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "clear-on-select": true,
      "selectLabel": ""
    },
    on: {
      "search-change": _vm.getResult,
      "select": _vm.openAddress
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title",
          class: props.option.available === true ? 'available' : 'unavailable'
        }, [_c('div', {
          staticClass: "row m-0 pb-1"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(_vm._s(props.option.values.WHOLE_ADDRESS))])]), _vm._v(" "), _c('div', {
          staticClass: "row m-0 font-sm"
        }, [_c('div', {
          staticClass: "col-sm-12"
        }, [_c('span', [_vm._v(_vm._s(props.option.values.DISTRICT))]), _vm._v(", \n                                                            "), _c('span', [_vm._v(_vm._s(props.option.values.REGION))])])])])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)])] : [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('multiselect', {
    attrs: {
      "reset-after": true,
      "id": "searchForeign",
      "data-testid": "client-address-search-foreign",
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat adresu v cizině",
      "open-direction": "bottom",
      "options": _vm.foreignAddresses,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "clear-on-select": true,
      "selectLabel": ""
    },
    on: {
      "search-change": _vm.getForeignAddressResult,
      "select": _vm.openForeignAddress
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title",
          class: props.option.available === true ? 'available' : 'unavailable'
        }, [_c('div', {
          staticClass: "row m-0 pb-1"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v(_vm._s(props.option.description))])])])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)])], _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-9"
  }, [_c('label', {
    attrs: {
      "for": "street"
    }
  }, [_vm._v("Ulice")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressForm.street),
      expression: "addressForm.street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-address-street",
      "aria-describedby": "streetHelp",
      "id": "street",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.addressForm.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressForm.street = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.street) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "streetError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.street.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "houseNumber"
    }
  }, [_vm._v("Číslo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressForm.house_number),
      expression: "addressForm.house_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-address-house-number",
      "aria-describedby": "houseNumberHelp",
      "id": "houseNumber",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.addressForm.house_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressForm.house_number = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.housenumber) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "houseNumberError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.housenumber.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "zip_code"
    }
  }, [_vm._v("PSČ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressForm.zip_code),
      expression: "addressForm.zip_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-address-zip-code",
      "aria-describedby": "zip_codeHelp",
      "id": "zip_code",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.addressForm.zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressForm.zip_code = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.zipcode) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "zipCodeError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.zipcode.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("Město")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressForm.city),
      expression: "addressForm.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-address-city",
      "aria-describedby": "cityHelp",
      "id": "city",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.addressForm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressForm.city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.city) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "cityError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.city.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "district"
    }
  }, [_vm._v("Okres")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressForm.district),
      expression: "addressForm.district"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-address-district",
      "aria-describedby": "districtHelp",
      "id": "district",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.addressForm.district)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressForm.district = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.district) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "districtError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.district.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "region"
    }
  }, [_vm._v("Kraj")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressForm.region),
      expression: "addressForm.region"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-testid": "client-address-region",
      "aria-describedby": "regionHelp",
      "id": "region",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.addressForm.region)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressForm.region = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addressError.region) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "regionError"
    }
  }, [_vm._v(_vm._s(_vm.addressError.region.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [(_vm.lastAddress) ? _c('span', [_vm._v("Předchozí adresa: " + _vm._s(_vm.lastAddress))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12 text-center"
  }, [(_vm.addressPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-testid": "client-address-save",
      "type": "submit"
    }
  }, [_vm._v("Uložit adresu")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])], 2)])]) : (_vm.client.address) ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table table_labeled table-bordered",
    attrs: {
      "data-testid": "client-address-table"
    }
  }, [_c('tr', {
    staticClass: "row m-0"
  }, [_c('td', {
    staticClass: "col-sm-12"
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("ulice a čp.")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.address.street)))])]), _vm._v(" "), _c('tr', {
    staticClass: "row m-0"
  }, [_c('td', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("PSČ")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.address.zip_code)))]), _vm._v(" "), _c('td', {
    staticClass: "col-sm-8"
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("obec")]), _vm._v(_vm._s(_vm._f("neverEmpty")(_vm.client.address.city)))])]), _vm._v(" "), _c('tr', {
    staticClass: "row m-0"
  }, [_c('td', {
    staticClass: "col-sm-12",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "td_label"
  }, [_vm._v("stát")]), _vm._v(_vm._s(_vm._f("neverEmpty")((_vm.client.address.country ? _vm.client.address.country.name : ''))))])])])]) : _vm._e()])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-157bc2c7","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/components/ClientAddress.vue
// module id = 328
// module chunks = 0